// import AWS from 'aws-sdk';
// import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const state = () => ({
  treesGeoJson: { features: [] },
  treesInProject: [],
  treesInProjectNearMe: [],
  treeList: [],
  selectedTree: [],
  selectedTreeVisits: [],
  selectedVisitDetails: {},
  latitude: 0,
  longitude: 0,
  boundingBoxString: '',
  showAddNewTree: false,
  goToLatLon: {},
  editTreeMode: false,
  moveTreeMode: false,
  healthcheckCounts: [],
});

const getters = {};

const mutations = {
  updateTreesInProject(state, data) {
    state.treesInProject = data;
  },
  updateTreesInProjectNearMe(state, data) {
    state.treesInProjectNearMe = data;
  },
  updateTreeList(state, data) {
    state.treeList = data;
  },
  updateSelectedTree(state, data) {
    state.selectedTree = data;
  },
  updateLatLong(state, data) {
    state.latitude = data[0];
    state.longitude = data[1];
  },
  updateBoundingBox(state, data) {
    state.boundingBoxString = data;
  },
  updateShowAddNewTree(state, data) {
    state.showAddNewTree = data;
  },
  updateGoToLatLon(state, obj) {
    state.goToLatLon = obj;
  },
  updateSelectedTreeVisits(state, arr) {
    state.selectedTreeVisits = arr;
  },
  updateSelectedVisitDetails(state, obj) {
    state.selectedVisitDetails = obj;
  },
  updateEditTreeMode(state, bool) {
    state.editTreeMode = bool;
  },
  updateMoveTreeMode(state, bool) {
    state.moveTreeMode = bool;
  },
  updateHealthcheckCounts(state, data) {
    state.healthcheckCounts = data;
  },
};

const actions = {
  async getTreesByMapExtent(context) {
    try {
      const polygonExtent = context.state.boundingBoxString;
      const response = await context.dispatch('protectedApiRequest', {
        route: `trees/extent/${polygonExtent}`,
        type: 'GET',
      });
      context.dispatch('convertToGeojson', response.data.data[0]);
    } catch (error) {
      console.warn(error);
    }
  },
  async getTreeById(context, arr) {
    try {
      let treeId = arr[0];
      let projectId = arr[1];
      const response = await context.dispatch('protectedApiRequest', {
        route: `tree?treeId=${treeId}&projectId=${projectId}`,
        type: 'GET',
      });
      if (response.status === 200) {
        try {
          const treeData = response.data.data[0];

          const photos = await context.dispatch(
            'populateTreePhotoDownloadUrls',
            treeData
          );
          treeData.photosUrlArray = photos;

          await context.commit('updateSelectedTree', treeData);

          // call procedure to get activies from revisit table
          context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
        } catch (error) {
          console.warn(error);
        }
      } else {
        console.warn(error);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async getTreeById_openMap(context, arr) {
    try {
      let treeId = arr[0];
      let projectId = arr[1];
      const response = await context.dispatch('protectedApiRequest', {
        route: `tree?treeId=${treeId}&projectId=${projectId}`,
        type: 'GET',
      });
      if (response.status === 200) {
        try {
          const treeData = response.data.data[0];

          const photos = await context.dispatch(
            'populateTreePhotoDownloadUrls',
            treeData
          );
          treeData.photosUrlArray = photos;

          await context.commit('updateSelectedTree', treeData);
          await context.commit('updateGoToLatLon', {
            lat: treeData.latitude,
            lon: treeData.longitude,
          });
          await context.commit('updateSelectedView', 'map');
          // call procedure to get activies from revisit table
        } catch (error) {
          console.warn(error);
        }
      } else {
        console.warn(error);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async populateTreePhotoDownloadUrls(context, treeData) {
    return new Promise((resolve, reject) => {
      try {
        let photos = treeData.photo_file;
        let photoIds = treeData.photo_unique_id;

        if (photos) {
          let photosArray = photos.split(',');
          let photosIdArray = photoIds.split(',');
          let photoUrlArray = [];
          let i = 0;
          if (photosArray.length > 0) {
            photosArray.forEach(async (photo, index) => {
              let photoTrimmed = photo.trim();
              let photoIdTrimmed = photosIdArray[index].trim();
              let params = {
                key: photoTrimmed,
              };
              const url = await context.dispatch(
                'getDownloadUrlFromS3',
                params
              );
              photoUrlArray.push({
                url: url,
                id: photoIdTrimmed,
                photoKey: photoTrimmed,
              });
              i++;
              // send each trimmed photo to s3 node to get download URL
              if (i == photosArray.length) {
                resolve(photoUrlArray);
              }
            });
          } else {
            resolve([]);
          }
        } else {
          resolve([]);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  async getAllTreesInProject(context, projectId) {
    try {
      const response = await context.dispatch('protectedApiRequest', {
        route: `trees/project/all?projectId=${projectId}`,
        type: 'GET',
      });
      context.commit('updateTreesInProject', response.data.data);
    } catch (error) {
      console.warn(error);
    }
  },
  async getAllTreesInProjectNearMe(context, arr) {
    try {
      const projectId = arr[0];
      const extent = arr[1];
      const response = await context.dispatch('protectedApiRequest', {
        route: `trees/project?projectId=${projectId}&extent=${extent}`,
        type: 'GET',
      });
      context.commit('updateTreesInProjectNearMe', response.data.data);
    } catch (error) {
      console.warn(error);
    }
  },
  async getTreeList(context) {
    try {
      const response = await context.dispatch('protectedApiRequest', {
        route: `trees/list`,
        type: 'GET',
      });
      context.commit('updateTreeList', response.data.data);
    } catch (error) {
      console.warn(error);
    }
  },
  async convertToGeojson(context, geoJson) {
    let geoJsonReformat = {
      type: 'FeatureCollection',
      features: [],
    };
    geoJson.forEach((item) => {
      geoJsonReformat.features.push(JSON.parse(item.point_geojson));
    });
    context.state.treesGeoJson = geoJsonReformat;
  },
  async createNewTree(context, data) {
    try {
      const projectId = data.projectId;
      const subId = data.subId;
      const inName = data.inName;
      const inLatitude = data.inLatitude;
      const inLongitude = data.inLongitude;
      const inAddress = data.inAddress;
      const rootConfig = data.rootConfig;
      const containerSize = data.containerSize;
      const caliperSize = data.caliperSize;
      const inDbh = data.inDbh;
      const inTreeheight = data.inTreeheight;
      const inNotes = data.inNotes;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: 'tree',
        type: 'POST',
        body: {
          projectId,
          subId,
          inName,
          inLatitude,
          inLongitude,
          inAddress,
          rootConfig,
          containerSize,
          caliperSize,
          inDbh,
          inTreeheight,
          inNotes,
        },
      });
      if (response.status === 200) {
        try {
          context.commit('updateSavingEdit', 1);
          await context.commit('updateLeftDrawer', { open: false });
          await context.commit('updateShowAddNewTree', false);
          await context.dispatch('getTreesByMapExtent');
          await context.commit('updateSelectedTree', response.data.data[0]);
          // call procedure to get activies from revisit table
          context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async editTree(context, data) {
    try {
      const projectId = data.projectId;
      const treeId = data.treeId;
      const subId = data.subId;
      const inName = data.inName;
      const inAddress = data.inAddress;
      const rootConfig = data.rootConfig;
      const containerSize = data.containerSize;
      const caliperSize = data.caliperSize;
      const inDbh = data.inDbh;
      const inTreeheight = data.inTreeheight;
      const inNotes = data.inNotes;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: 'tree',
        type: 'PUT',
        body: {
          projectId,
          treeId,
          subId,
          inName,
          inAddress,
          rootConfig,
          containerSize,
          caliperSize,
          inDbh,
          inTreeheight,
          inNotes,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          await context.dispatch('getTreeById', [data.treeId, data.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
          await context.commit('updateEditTreeMode', false);
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async editTreeLocation(context, obj) {
    try {
      const latitude = obj.latitude;
      const longitude = obj.longitude;
      const treeId = obj.treeId;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: 'tree/location',
        type: 'PUT',
        body: {
          latitude,
          longitude,
          treeId,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async deletePhotoTree(context, params) {
    try {
      const response = await context.dispatch('protectedApiRequest', {
        route: `photo/tree/delete`,
        type: 'POST',
        body: {
          id: params.id,
          key: params.photoKey,
        },
      });

      if (response.status == 200) {
        context.dispatch('getTreeById', [
          context.state.selectedTree.tree_id,
          context.state.selectedTree.project_id,
        ]);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async addPhotoToTree(context, file) {
    try {
      const uuid = uuidv4();
      const params = {
        file: file,
        fileName: 'testFile.png',
        uuid: uuidv4(),
      };
      await context.dispatch('uploadPhotoToS3', params);
    } catch (error) {
      console.warn(error);
    }
    // we need a tree ID, we will get tree id from tree details
    // 1. on upload photo trigger, get file and metadata
    // 2. convert file to BLOB
    // 3. make a request to teh API for an uploadURL, this takes the bucket, filetype, key/name
    // 4. make PUT fetch request with uploadUrl and BLOB, and filetype, and key
    // 5. make POST request: procedure name: call insert_photo_tree(treeId (INT), photoFile (STR));
    // api path: POST photo/tree
    // let body = {
    //   treeId: '986687',
    //   photoFile: 'mattsPhoto.jpg'
    //   projectId: '1262' // admin project id for testing, can also be null
    // }
    // 6. refresh photos on screen, by calling getTreeById(treeId)
  },
  async getVisitsByTreeId(context, val) {
    //clear from prev request
    try {
      let treeId = val;
      const response = await context.dispatch('protectedApiRequest', {
        route: `trees/visits?treeId=${treeId}`,
        type: 'GET',
      });
      if (response.status === 200) {
        try {
          const treeVisits = response.data.data;

          await context.commit('updateSelectedTreeVisits', treeVisits);
        } catch (error) {
          console.warn(error);
        }
      } else {
        console.warn(error);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async getVisitDetails(context, val) {
    try {
      let visitId = val;
      const response = await context.dispatch('protectedApiRequest', {
        route: `trees/visit?visitId=${visitId}`,
        type: 'GET',
      });
      if (response.status === 200) {
        try {
          const visitDetails = response.data.data[0];
          await context.commit('updateSelectedVisitDetails', visitDetails);
        } catch (error) {
          console.warn(error);
        }
      } else {
        console.warn(error);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async getHealthcheckCounts(context, data) {
    try {
      const subId = data[0];
      const treeId = data[1];
      const response = await context.dispatch('protectedApiRequest', {
        route: `tree/healthcheck?subId=${subId}&treeId=${treeId}`,
        type: 'GET',
      });
      context.commit('updateHealthcheckCounts', response.data.data);
    } catch (error) {
      console.warn(error);
    }
  },
  async insertHealthCheck(context, obj) {
    try {
      const treeId = obj.treeId;
      const subId = obj.subId;
      const projectId = obj.projectId;
      const inDbh = obj.inDbh;
      const inTreeheight = obj.inTreeheight;
      const inNotes = obj.inNotes;
      const fineTwigDieback = obj.fineTwigDieback;
      const leafDefoliation = obj.leafDefoliation;
      const leafDiscoloration = obj.leafDiscoloration;
      const crownVigor = obj.crownVigor;
      const crownLightExposure = obj.crownLightExposure;
      const crownDensityTrans = obj.crownDensityTrans;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: '/tree/healthcheck',
        type: 'POST',
        body: {
          treeId,
          subId,
          projectId,
          inDbh,
          inTreeheight,
          inNotes,
          fineTwigDieback,
          leafDefoliation,
          leafDiscoloration,
          crownVigor,
          crownLightExposure,
          crownDensityTrans,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          obj.tree;
          await context.dispatch('getTreeById', [obj.treeId, obj.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async editHealthCheck(context, obj) {
    try {
      const visitId = obj.visitId;
      const treeId = obj.treeId;
      const subId = obj.subId;
      const projectId = obj.projectId;
      const inDbh = obj.inDbh;
      const inTreeheight = obj.inTreeheight;
      const inNotes = obj.inNotes;
      const fineTwigDieback = obj.fineTwigDieback;
      const leafDefoliation = obj.leafDefoliation;
      const leafDiscoloration = obj.leafDiscoloration;
      const crownVigor = obj.crownVigor;
      const crownLightExposure = obj.crownLightExposure;
      const crownDensityTrans = obj.crownDensityTrans;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: '/tree/healthcheck',
        type: 'PUT',
        body: {
          visitId,
          projectId,
          inDbh,
          inTreeheight,
          inNotes,
          fineTwigDieback,
          leafDefoliation,
          leafDiscoloration,
          crownVigor,
          crownLightExposure,
          crownDensityTrans,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          obj.tree;
          await context.dispatch('getTreeById', [obj.treeId, obj.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
          await context.commit('updateEditTreeMode', false);
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async insertPestDetection(context, obj) {
    try {
      const treeId = obj.treeId;
      const projectId = obj.projectId;
      const inDbh = obj.inDbh;
      const inTreeheight = obj.inTreeheight;
      const inNotes = obj.inNotes;
      const exitHoles = obj.exitHoles;
      const inExudation = obj.inExudation;
      const inEggs = obj.inEggs;
      const adultInsectOrLarvaAppearance = obj.adultInsectOrLarvaAppearance;
      const fruitDamage = obj.fruitDamage;
      const holesInLeaves = obj.holesInLeaves;
      const inFrass = obj.inFrass;
      const epicormicSprouts = obj.epicormicSprouts;
      const blonding = obj.blonding;
      const sShapedGalleries = obj.sShapedGalleries;
      const barkFissures = obj.barkFissures;
      const deadBark = obj.deadBark;
      const inGalls = obj.inGalls;
      const deadTwigs = obj.deadTwigs;
      const discolorationDeciduous = obj.discolorationDeciduous;
      const discolorationConifer = obj.discolorationConifer;
      const wiltedLeaves = obj.wiltedLeaves;
      const prematureLeafLoss = obj.prematureLeafLoss;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: '/tree/pestdetection',
        type: 'POST',
        body: {
          treeId,
          projectId,
          inDbh,
          inTreeheight,
          inNotes,
          exitHoles,
          inExudation,
          inEggs,
          adultInsectOrLarvaAppearance,
          fruitDamage,
          holesInLeaves,
          inFrass,
          epicormicSprouts,
          blonding,
          sShapedGalleries,
          barkFissures,
          deadBark,
          inGalls,
          deadTwigs,
          discolorationDeciduous,
          discolorationConifer,
          wiltedLeaves,
          prematureLeafLoss,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          obj.tree;
          await context.dispatch('getTreeById', [obj.treeId, obj.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async editPestDetection(context, obj) {
    try {
      const visitId = obj.visitId;
      const projectId = obj.projectId;
      const inDbh = obj.inDbh;
      const inTreeheight = obj.inTreeheight;
      const inNotes = obj.inNotes;
      const exitHoles = obj.exitHoles;
      const inExudation = obj.inExudation;
      const inEggs = obj.inEggs;
      const adultInsectOrLarvaAppearance = obj.adultInsectOrLarvaAppearance;
      const fruitDamage = obj.fruitDamage;
      const holesInLeaves = obj.holesInLeaves;
      const inFrass = obj.inFrass;
      const epicormicSprouts = obj.epicormicSprouts;
      const blonding = obj.blonding;
      const sShapedGalleries = obj.sShapedGalleries;
      const barkFissures = obj.barkFissures;
      const deadBark = obj.deadBark;
      const inGalls = obj.inGalls;
      const deadTwigs = obj.deadTwigs;
      const discolorationDeciduous = obj.discolorationDeciduous;
      const discolorationConifer = obj.discolorationConifer;
      const wiltedLeaves = obj.wiltedLeaves;
      const prematureLeafLoss = obj.prematureLeafLoss;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: '/tree/pestdetection',
        type: 'PUT',
        body: {
          visitId,
          projectId,
          inDbh,
          inTreeheight,
          inNotes,
          exitHoles,
          inExudation,
          inEggs,
          adultInsectOrLarvaAppearance,
          fruitDamage,
          holesInLeaves,
          inFrass,
          epicormicSprouts,
          blonding,
          sShapedGalleries,
          barkFissures,
          deadBark,
          inGalls,
          deadTwigs,
          discolorationDeciduous,
          discolorationConifer,
          wiltedLeaves,
          prematureLeafLoss,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          obj.tree;
          await context.dispatch('getTreeById', [obj.treeId, obj.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
          await context.commit('updateEditTreeMode', false);
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async insertTreeCare(context, obj) {
    try {
      const treeId = obj.treeId;
      const projectId = obj.projectId;
      const inDbh = obj.inDbh;
      const inTreeheight = obj.inTreeheight;
      const inNotes = obj.inNotes;
      const timeSpent = obj.timeSpent;
      const stewardshipTasks = obj.stewardshipTasks;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: '/tree/treecare',
        type: 'POST',
        body: {
          treeId,
          projectId,
          inDbh,
          inTreeheight,
          inNotes,
          timeSpent,
          stewardshipTasks,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          obj.tree;
          await context.dispatch('getTreeById', [obj.treeId, obj.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async editTreeCare(context, obj) {
    try {
      const visitId = obj.visitId;
      const projectId = obj.projectId;
      const inDbh = obj.inDbh;
      const inTreeheight = obj.inTreeheight;
      const inNotes = obj.inNotes;
      const timeSpent = obj.timeSpent;
      const stewardshipTasks = obj.stewardshipTasks;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: '/tree/treecare',
        type: 'PUT',
        body: {
          visitId,
          projectId,
          inDbh,
          inTreeheight,
          inNotes,
          timeSpent,
          stewardshipTasks,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          obj.tree;
          await context.dispatch('getTreeById', [obj.treeId, obj.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
          await context.commit('updateEditTreeMode', false);
        } catch (error) {
          console.warn(error);
        }
        return true;
      } else {
        context.commit('updateSavingEdit', 2);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async addTreeToProject(context, obj) {
    try {
      let projectId = obj.projectId;
      let treeId = obj.treeId;
      context.commit('updateSavingEdit', 0);
      const response = await context.dispatch('protectedApiRequest', {
        route: '/tree/projectxtree',
        type: 'POST',
        body: {
          projectId,
          treeId,
        },
      });
      if (response.status === 200) {
        context.commit('updateSavingEdit', 1);
        try {
          obj.tree;
          await context.dispatch('getTreeById', [obj.treeId, obj.projectId]);
          await context.commit('updateLeftDrawer', {
            open: false,
            content: '',
          });
          await context.commit('updateLeftDrawer', {
            open: true,
            content: 'treehome',
          });
          await context.commit('updateEditTreeMode', false);
        } catch (error) {
          console.warn(error);
        }
      } else {
        context.commit('updateSavingEdit', 2);
        console.warn(error);
      }
    } catch (error) {
      console.warn(error);
    }
  },
};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
